const INITIAL_STATE = {
  openMenu: null,
  isNavigationOpen: false,
}

export default function navigation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_OPEN_MENU':
      return { ...state, openMenu: action.payload }
    case 'OPEN_NAVIGATION':
      return { ...state, isOpen: true }
    case 'CLOSE_NAVIGATION':
      return { ...state, isOpen: false }
    default:
      return state
  }
}

export function getDoesMenuContainId(state, openMenu) {
  if (state.id == openMenu) {
    return true
  }

  const ids = state.submenus
    .flatMap(submenu => {
      return [submenu, ...submenu.submenus]
    })
    .flatMap(menu => menu.id)

  return ids.includes(openMenu)
}
